import React from "react";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";

import { FILTERS } from "./utils";

/**
 * @component
 * @description Reusable component for period toggle buttons (Weeks/Months) used across clinician dashboard modules
 * @param {Object} props
 * @param {string} props.period - The current selected period (weeks or months)
 * @param {function} props.onPeriodChange - The function to handle period changes
 * @param {boolean} props.isSmallScreen - Whether the screen is small
 * @returns {JSX.Element} Period toggle buttons (Weeks/Months)
 */
const PeriodToggleButton = ({ period, onPeriodChange, isSmallScreen = false }) => {
  const dataTestId = "period-toggle-button";

  return (
    <ToggleButtonGroup
      value={period}
      size="small"
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) onPeriodChange(newValue);
      }}
      data-testid={dataTestId}
      sx={{
        width: isSmallScreen ? "100%" : "auto",
        marginBottom: isSmallScreen ? 3 : "auto",
        marginTop: isSmallScreen ? 2 : "auto",
      }}
      data-small-screen={isSmallScreen}
    >
      <ToggleButton
        value={FILTERS.BY_WEEKS}
        aria-label={FILTERS.BY_WEEKS}
        sx={{ width: isSmallScreen ? "100%" : "auto" }}
        data-testid={`${dataTestId}-weeks`}
      >
        Weeks
      </ToggleButton>
      <ToggleButton
        value={FILTERS.BY_MONTHS}
        aria-label={FILTERS.BY_MONTHS}
        sx={{ width: isSmallScreen ? "100%" : "auto" }}
        data-testid={`${dataTestId}-months`}
      >
        Months
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default PeriodToggleButton;
